/* BUNDLE10 promo band + picker.

   The picker reuses the calculator's markup (mc-custom-select--rich, mc-swatch,
   mc-qty-stepper) but mulch-calculator.js only binds inside its own
   [data-mc-calculator] element, so the same interactions are driven here.
   Everything is delegated off document so it survives re-renders. */
(function () {
  if (window.__bundlePromoInit) return;
  window.__bundlePromoInit = true;

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function state(picker) {
    if (!picker) return { handle: null, id: null, price: 0, qty: 1 };
    var opt = picker.querySelector('[data-bundle-option].is-selected') ||
              picker.querySelector('[data-bundle-option]');
    var handle = opt && opt.getAttribute('data-handle');
    var set = handle ? picker.querySelector('[data-bundle-variants-for="' + handle + '"]') : null;
    var variant = set ? (set.querySelector('[data-bundle-variant].is-selected') ||
                         set.querySelector('[data-bundle-variant]')) : null;
    var qtyEl = picker.querySelector('[data-bundle-qty]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var id = variant ? variant.getAttribute('data-variant-id')
                     : (opt && opt.getAttribute('data-variant-id'));
    var price = variant ? parseInt(variant.getAttribute('data-variant-price'), 10)
                        : (opt ? parseInt(opt.getAttribute('data-variant-price'), 10) : 0);
    return { handle: handle, id: id, price: price, qty: qty < 1 ? 1 : qty };
  }

  function refresh(picker) {
    if (!picker) return;
    var st = state(picker);

    var priceEl = picker.querySelector('[data-bundle-price]');
    if (priceEl && st.price) priceEl.textContent = money(st.price * st.qty);

    var set = st.handle ? picker.querySelector('[data-bundle-variants-for="' + st.handle + '"]') : null;
    var sel = set && set.querySelector('[data-bundle-variant].is-selected');
    var label = st.handle ? picker.querySelector('[data-bundle-variant-label-for="' + st.handle + '"]') : null;
    var nameEl = label && label.querySelector('[data-mc-swatch-color-name]');
    if (nameEl && sel) nameEl.textContent = (sel.getAttribute('title') || '').toLowerCase();
  }

  function closeMenu(picker) {
    if (!picker) return;
    var menu = picker.querySelector('[data-bundle-select-menu]');
    var trigger = picker.querySelector('[data-bundle-select-trigger]');
    if (menu) menu.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function selectProduct(picker, option) {
    if (!picker || !option) return;
    picker.querySelectorAll('[data-bundle-option]').forEach(function (o) {
      var on = o === option;
      o.classList.toggle('is-selected', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // mirror the chosen row into the trigger, the way the calculator does
    var value = picker.querySelector('[data-bundle-select-value]');
    var inner = option.querySelector('.mc-border-option-inner');
    if (value && inner) value.innerHTML = inner.innerHTML;

    var handle = option.getAttribute('data-handle');
    picker.querySelectorAll('[data-bundle-variants-for]').forEach(function (el) {
      el.classList.toggle('is-hidden', el.getAttribute('data-bundle-variants-for') !== handle);
    });
    picker.querySelectorAll('[data-bundle-variant-label-for]').forEach(function (el) {
      el.classList.toggle('is-hidden', el.getAttribute('data-bundle-variant-label-for') !== handle);
    });

    closeMenu(picker);
    refresh(picker);
  }

  function setCardOpen(picker, open) {
    if (!picker) return;
    var card = picker.querySelector('[data-bundle-card]');
    var trigger = picker.querySelector('[data-bundle-card-trigger]');
    var panel = picker.querySelector('[data-bundle-panel]');
    if (!card) return;
    card.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function isChecked(picker) {
    if (!picker) return false;
    var card = picker.querySelector('[data-bundle-card]');
    return !!(card && card.classList.contains('is-open'));
  }

  /* Checked add-ons ride along with the page's own Add to cart, which is what
     "Add them to your mulch order" means — one action, mulch plus the extras. */
  function pendingItems() {
    var items = [];
    document.querySelectorAll('[data-bundle-picker]').forEach(function (picker) {
      if (picker.hasAttribute('hidden') || picker.style.display === 'none') return;
      if (!isChecked(picker)) return;
      var st = state(picker);
      if (st.id) items.push({ id: Number(st.id), quantity: st.qty, properties: { _bundle_promo: 'BUNDLE10' } });
    });
    return items;
  }

  /* The band belongs to the Enter Quantity tab. On the Mulch Calculator tab the
     calculator has its own add-on rows, so hide the promo there and restore it when
     the shopper switches back. Watching the class rather than the click, because the
     theme's own script is what actually flips the tab. */
  function syncTabVisibility() {
    var calcTab = document.querySelector('[data-tab="calculate-quantity"]');
    if (!calcTab) return;
    var onCalculator = calcTab.classList.contains('is-active');

    document.querySelectorAll('[data-bundle-band="mulch-pdp"]').forEach(function (band) {
      band.style.display = onCalculator ? 'none' : '';
      var node = band.nextElementSibling;
      while (node && node.hasAttribute && node.hasAttribute('data-bundle-picker')) {
        node.style.display = onCalculator ? 'none' : '';
        node = node.nextElementSibling;
      }
    });
  }

  function watchTabs() {
    var tabs = document.querySelector('.plug-calculator__tabs');
    if (!tabs) return;
    syncTabVisibility();
    new MutationObserver(syncTabVisibility).observe(tabs, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchTabs);
  } else {
    watchTabs();
  }

  document.addEventListener('click', function (e) {
    /* the page's own Add to cart also adds any ticked bundle add-ons */
    var mainAtc = e.target.closest('.addtocart');
    if (mainAtc && !mainAtc.closest('[data-bundle-picker]')) {
      var extras = pendingItems();
      if (extras.length) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: extras })
        }).catch(function () {});
      }
      return;
    }

    // checkbox / header opens the card, exactly like the calculator's add-on rows
    var cardTrigger = e.target.closest('[data-bundle-card-trigger]');
    if (cardTrigger) {
      e.preventDefault();
      var pkr = cardTrigger.closest('[data-bundle-picker]');
      setCardOpen(pkr, !isChecked(pkr));
      refresh(pkr);
      return;
    }

    // reveal / hide a picker from the band
    var toggle = e.target.closest('[data-bundle-toggle]');
    if (toggle) {
      e.preventDefault();
      var kind = toggle.getAttribute('data-bundle-toggle');
      var band = toggle.closest('[data-bundle-band]');
      var scope = band ? band.parentNode : document;
      var picker = scope.querySelector('[data-bundle-picker="' + kind + '"]');
      if (!picker) return;
      var opening = picker.hasAttribute('hidden');
      picker.toggleAttribute('hidden', !opening);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        setCardOpen(picker, true);
        refresh(picker);
        picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    var pickerEl = e.target.closest('[data-bundle-picker]');

    // open / close the rich select
    var selTrigger = e.target.closest('[data-bundle-select-trigger]');
    if (selTrigger && pickerEl) {
      e.preventDefault();
      var menu = pickerEl.querySelector('[data-bundle-select-menu]');
      var open = menu.hidden;
      menu.hidden = !open;
      selTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // choose a product
    var option = e.target.closest('[data-bundle-option]');
    if (option && pickerEl) {
      e.preventDefault();
      selectProduct(pickerEl, option);
      return;
    }

    // choose a colour or a size
    var variant = e.target.closest('[data-bundle-variant]');
    if (variant && pickerEl) {
      e.preventDefault();
      variant.parentNode.querySelectorAll('[data-bundle-variant]').forEach(function (n) {
        n.classList.toggle('is-selected', n === variant);
      });
      refresh(pickerEl);
      return;
    }

    // quantity stepper
    var step = e.target.closest('[data-bundle-qty-step]');
    if (step && pickerEl) {
      e.preventDefault();
      var input = pickerEl.querySelector('[data-bundle-qty]');
      var next = (parseInt(input.value, 10) || 1) + (parseInt(step.getAttribute('data-bundle-qty-step'), 10) || 0);
      input.value = next < 1 ? 1 : next;
      refresh(pickerEl);
      return;
    }

    // clicking outside closes any open select
    document.querySelectorAll('[data-bundle-picker]').forEach(function (pk) {
      if (!pk.contains(e.target)) closeMenu(pk);
    });
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-bundle-qty]')) {
      refresh(e.target.closest('[data-bundle-picker]'));
    }
  });
})();
